/**
 * Registry of DICOM requests the app aborted ON PURPOSE (an MPR session torn
 * down mid-load, a "Try again" that must issue fresh requests). Cornerstone's
 * xhrRequest rejects with the XMLHttpRequest itself, and that rejection fans
 * out as IMAGE_LOAD_FAILED — which both the LAN circuit breaker and the Sentry
 * forwarder consume. Neither should treat a deliberate abort as a failure.
 *
 * Dependency-free on purpose: captureViewerError imports this, and it must not
 * drag `@cornerstonejs/dicom-image-loader` into every component's graph.
 */
const deliberatelyAborted = new WeakSet();
/** Record that `xhr` is about to be aborted by the app, not by the network. */
export function markDeliberateAbort(xhr) {
    deliberatelyAborted.add(xhr);
}
/**
 * True when `error` is the rejection of a request the app aborted itself.
 *
 * Cornerstone's xhrRequest rejects with the bare XMLHttpRequest, but the
 * wadouri loader wraps it (`{ error: xhr }`, or `{ error, dataSet }` when the
 * decode failed after download) before cs3d re-emits it on IMAGE_LOAD_FAILED —
 * so the marked object is usually one `.error` hop down. Walk a couple of
 * levels rather than trusting a single shape.
 */
export function isDeliberateAbort(error) {
    let current = error;
    for (let depth = 0; depth < 3 && typeof current === 'object' && current !== null; depth++) {
        if (deliberatelyAborted.has(current))
            return true;
        current = current.error;
    }
    return false;
}
